import {isString} from "./primitives";

export const isVideoContentType = (contentType?: string) => {
    return isString(contentType) && contentType.includes("video");
};

export const isImageContentType = (contentType?: string) => {
    return isString(contentType) && contentType.includes("image");
};
